export enum EListingBannerType {
  Tgb = 'tgb',
  Parallax = 'parallax',
}

export const BANNER_POSITION_TYPES: Record<number, EListingBannerType> = {
  5: EListingBannerType.Tgb,
  10: EListingBannerType.Parallax,
  15: EListingBannerType.Tgb,
  20: EListingBannerType.Parallax,
  25: EListingBannerType.Tgb,
};
